<script type="ts">
	import { fly, fade } from 'svelte/transition';

	export let noClose = false;
	let isOpen = false;

	export const open = () => {
		isOpen = true;
		console.log('open in modal');
	};

	export const close = () => {
		if (!noClose) isOpen = false;
	};
</script>

{#if isOpen}
	<div
		class="relative z-50 modal"
		on:introstart
		on:outroend
		transition:fade
		aria-labelledby="modal-title"
		role="dialog"
		aria-modal="true"
	>
		<div
			class="absolute top-0 bottom-0 left-0 right-0 inset-0 bg-black bg-opacity-75"
			on:click={() => close()}
		/>

		<div
			class="flex min-h-full items-center justify-center md:p-4 text-center  sm:p-0"
			transition:fly={{ y: 50 }}
		>
			<div
				class="relative transform rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full max-w-screen-lg max-h-screen overflow-auto"
			>
				{#if !noClose}
					<button class="absolute top-2 right-2" on:click={() => close()}>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="16"
							height="16"
							fill="currentColor"
							class="bi bi-x-lg"
							viewBox="0 0 16 16"
						>
							<path
								d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"
							/>
						</svg>
					</button>
				{/if}

				<slot />
			</div>
		</div>
	</div>
{/if}

<style>
	.modal {
		position: fixed;
		top: 0;
		bottom: 0;
		right: 0;
		left: 0;
	}
</style>
